import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import RootfilesGrid from '../components/Grid';
import { RootfileProvider } from '../store';

import RootfileFormLayout from './Form';

export default function RootfilesGridLayout() {
  return <RootfileProvider>
    <RootfilesGrid />
    <Router>
      <PrivateRoute path={["/cms/settings/rootfiles/add", "/cms/settings/rootfiles/:id"]} component={RootfileFormLayout} />
    </Router>
  </RootfileProvider>;
}
